/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountPatchSchema
 */
export interface AccountPatchSchema {
    /**
     * 
     * @type {number}
     * @memberof AccountPatchSchema
     */
    creditLimit: number;
}

/**
 * Check if a given object implements the AccountPatchSchema interface.
 */
export function instanceOfAccountPatchSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "creditLimit" in value;

    return isInstance;
}

export function AccountPatchSchemaFromJSON(json: any): AccountPatchSchema {
    return AccountPatchSchemaFromJSONTyped(json, false);
}

export function AccountPatchSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountPatchSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'creditLimit': json['credit_limit'],
    };
}

export function AccountPatchSchemaToJSON(value?: AccountPatchSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'credit_limit': value.creditLimit,
    };
}

